import moment from "moment";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import useSWR from "swr";
import useAuth from "../../../../initialpage/hooks/useAuth";
import { API } from "../../StoreComponents/conflict";
import "../../StoreComponents/storeStyle.css";
import "./UserReports.css";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const UserReports = () => {
  const user = JSON.parse(Cookies.get("user") || '{}');
  const employee_id = user?.employe_id;
  const [printButton, setPrintButton] = useState(false);
  const [monthDate, setMonthDate] = useState("");
  const [yearDate, setYearDate] = useState("");
  const [typeError, setTypeError] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [openElement, setOpenElement] = useState(false);
  // get UserReport Data
  const {
    data: UserReport,
    error,
    mutate,
  } = useSWR(
    (employee_id && fromDate) || toDate || monthDate || yearDate
      ? `store/reports/user/requisitions?hrid=${employee_id}&fdate=${fromDate}&tdate=${toDate}&month=${monthDate}&year=${yearDate}`
      : null,
    fetcher
  );

  console.log(UserReport);

  // get year select Data
  let presentYear = new Date().getFullYear();
  let yearMap = [];
  for (let i = 2022; i <= presentYear; i++) {
    yearMap.push(i);
  }
  // toggle seach button
  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };

  //     // toggle seach button
  //   const handleToggle = () => {
  //     if (!openElement ) {
  //       setTypeError("field Required");
  //       setOpenElement(false);
  //       setPrintButton(false);
  //     } else {
  //       setOpenElement(true);
  //       setPrintButton(true);
  //     }
  //   };

  return (
    <>
      <Helmet>
        <title>Reports - BBA STORE</title>
        <meta name="description" content="Reports - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              BBA Store Requisition Reports
            </h3>
          </div>
          <div
            style={{ background: "white", borderRadius: "10px" }}
            className="p-3"
          >
            <div className="add_category text-center">
              <div className="row mx-3">
                <div className="col-6 col-md-4 col-lg-3">
                  <label htmlFor="From_date">From Date</label>
                  <input
                    type="date"
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                    className="input-field-new p-2"
                  />
                </div>

                <div className="col-6 col-md-4 col-lg-3">
                  <label htmlFor="To_date">To Date</label>
                  <input
                    type="date"
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                    className="input-field-new p-2"
                  />
                </div>
                <div className="col-12 col-md-4 col-lg-3">
                  <label htmlFor="From_Date" className="text-start">
                    Month
                  </label>
                  <select
                    className="form-select input-field-existing fs-6"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setMonthDate(e.target.value);
                    }}
                  >
                    <option value="">select Month</option>
                    <option value="January">January</option>
                    <option value="February">February</option>
                    <option value="March">March</option>
                    <option value="April">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="August">August</option>
                    <option value="September">September</option>
                    <option value="October">October</option>
                    <option value="November">November</option>
                    <option value="December">December</option>
                  </select>
                </div>
                <div className="col-12 col-md-4 col-lg-3">
                  <label htmlFor="To_Date">Year</label>
                  <select
                    className="form-select input-field-existing fs-6"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setYearDate(e.target.value);
                    }}
                  >
                    <option value="">select Year</option>
                    {yearMap &&
                      yearMap.map((product) => (
                        <option value={product}>{product}</option>
                      ))}
                  </select>
                </div>
              </div>
              <br />
              <button
                onClick={handleToggle}
                type="button"
                className="mt-3 px-5 btn btn-color_store"
              >
                <i className="fa fa-search"></i>
                <span> Search</span>
              </button>
            </div>

            <div
              className={
                openElement
                  ? "category show mb-3 table-container p-2"
                  : "category my-4 table-container p-2"
              }
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div className="row mt-5">
                <div className="col-12">
                  <div className="table-responsive-sm storeTableFont">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr className="text-center tableColor">
                          <th>S/N</th>
                          <th>DATE & TIME</th>
                          <th>NAME</th>
                          <th>DESIGNATION</th>
                          <th>DEPARTMENT</th>
                          <th>REQUISITIONS</th>
                          <th>APPROVED</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      {UserReport && (
                        <tbody>
                          {UserReport?.map((product, index) => (
                            <tr className="text-center" key={index}>
                              <td>{++index}</td>
                              <td>
                                {product.REQUITIME} ,{" "}
                                {moment(new Date(product.REQUIDATE)).format(
                                  " DD-MM-YYYY"
                                )}
                              </td>
                              <td>{product.NAME_ENGLISH} </td>
                              <td>{product.DESIGNATION}</td>
                              <td>{product.DEPARTEMENT}</td>
                              <td>{product.TOTAL_PROREQUQTY}</td>
                              <td>{product.TOTAl_APROQTY}</td>
                              {/* Actions */}

                              {product.TOTAl_APROQTY > 0 ? (
                                <td>
                                  <Link
                                    to={`/requisition/userReport/slip/${product.REQID}`}
                                  >
                                    {" "}
                                    <button
                                      data-bs-toggle="tooltip"
                                      title="View"
                                      type="button"
                                      className="btn btn-red_store px-3"
                                    >
                                      <i className="fa fa-eye"></i>
                                    </button>
                                  </Link>
                                </td>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserReports;
